import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch"

const deletePriceListDiscounts = (
    token: string,
    backend: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}price_list_discounts/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deletePriceListDiscounts;
